import { AnnouncementBar } from "../components/forge/AnnouncementBar";
import { Navbar } from "../components/forge/Navbar";
import { Hero } from "../components/forge/Hero";
import { Marquee } from "../components/forge/Marquee";
import { ProblemSection } from "../components/forge/ProblemSection";
import { HowItWorks } from "../components/forge/HowItWorks";
import { WhatsNew } from "../components/forge/WhatsNew";
import { Transformations } from "../components/forge/Transformations";
import { FeaturesBento } from "../components/forge/FeaturesBento";
import { SampleDayPlan } from "../components/forge/SampleDayPlan";
import { GoalSelector } from "../components/forge/GoalSelector";
import { AppScreens } from "../components/forge/AppScreens";
import { UsageStrip } from "../components/forge/UsageStrip";
import { CoachSection } from "../components/forge/CoachSection";
import { Testimonials } from "../components/forge/Testimonials";
import { ValueStack } from "../components/forge/ValueStack";
import { ComparisonTable } from "../components/forge/ComparisonTable";
import { Pricing } from "../components/forge/Pricing";
import { FAQSection } from "../components/forge/FAQSection";
import { FinalCTA } from "../components/forge/FinalCTA";
import { Footer } from "../components/forge/Footer";
import { StickyMobileCTA } from "../components/forge/StickyMobileCTA";

export default function Landing() {
  return (
    <div className="relative bg-[#0A0A0B] font-body" data-testid="forge-landing-page">
      <div className="fixed inset-0 z-0 pointer-events-none forge-gridlines" />
      <div className="fixed inset-0 z-0 pointer-events-none forge-grain" />
      <div className="fixed top-0 inset-x-0 z-50">
        <AnnouncementBar />
        <Navbar />
      </div>
      <main className="relative z-10">
        <Hero />
        <Marquee />
        <ProblemSection />
        <HowItWorks />
        <WhatsNew />
        <Transformations />
        <FeaturesBento />
        <SampleDayPlan />
        <GoalSelector />
        <AppScreens />
        <UsageStrip />
        <CoachSection />
        <Testimonials />
        <ValueStack />
        <ComparisonTable />
        <Pricing />
        <FAQSection />
        <FinalCTA />
      </main>
      <div className="relative z-10">
        <Footer />
      </div>
      <StickyMobileCTA />
    </div>
  );
}
